import styled, { css } from 'styled-components'
import { white, grayLight, gray } from '@bufferapp/ui/style/colors'

import { flexCol } from '~/shared/styles/layout'

const backgroundStyles = css`
  background: ${white};
  border: 1px solid ${gray};
  border-radius: 4px;
`

/**
 *
 */
export const Wrapper = styled.div`
  ${flexCol}
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  & > * {
    margin-bottom: 16px;
  }

  & > :last-child {
    margin-bottom: 0px;
  }
`

export const BannerWrapper = styled.div`
  ${backgroundStyles}
  width: 100%;
  flex-basis: 0;
`

export const PostWrapper = styled.div`
  ${backgroundStyles}
  ${flexCol}
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin-bottom: 0px;

  &.empty-state {
    display: flex;
    justify-content: center;
  }
`

export const Header = styled.div`
  width: 100%;
  padding: 8px;
  border-bottom: 1px solid ${grayLight};
`

export const Body = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`
